let cleverTapAnonymousId = null;

export const pushCleverTapEvent = (arg1, arg2 = {}) => {
  const isObject = typeof arg1 === "object";

  const eventName = isObject ? arg1.eventName : arg1;
  const userData = isObject ? arg1.userData || {} : arg2 || {};
  const pageName = isObject ? (arg1.pageName || "") : (arg2.PageName || "");
  const eventData = isObject ? (arg1.eventData || {}) : (arg2 || {});

  // Ensure phone number is cleaned and formatted
  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/[\s()-]/g, '');
    if (cleaned.startsWith('+')) return cleaned;
    const defaultCountryCode = '+91';
    return `${defaultCountryCode}${cleaned}`;
  };

  if (typeof window !== "undefined" && typeof window.clevertap !== "undefined") {
    const onCleverTapReady = () => {
      try {
        cleverTapAnonymousId = localStorage.getItem("clevertapAnonymousId");
        if (!cleverTapAnonymousId || cleverTapAnonymousId === "null" || cleverTapAnonymousId === "") {
          cleverTapAnonymousId = window.clevertap.getCleverTapID?.();

          if (cleverTapAnonymousId && cleverTapAnonymousId !== "null") {
            try {
              localStorage.setItem("clevertapAnonymousId", cleverTapAnonymousId);
            } catch {
              // localStorage might fail (e.g. incognito mode), safely ignore
            }
          } else {
            cleverTapAnonymousId = null;
          }
        }

        if (cleverTapAnonymousId) {
          const profile = {
            Identity: cleverTapAnonymousId,
            "MSG-push": true,
          };

          if (userData.phoneNumber || userData.number || userData.Phone) {
            const formattedPhone = formatPhoneNumber(userData.phoneNumber || userData.number || userData.Phone);
            profile.Phone = formattedPhone;
            profile["MSG-sms"] = true;
            profile['MSG-whatsapp'] = true;
          }

          if (userData.email) {
            profile.Email = userData.email || "";
            profile['MSG-email'] = true;
          }
          if (userData.name) {
            profile.Name = userData.name || "";
          }
          if (userData.companyName) {
            profile.Company = userData.companyName;
          }
          if (userData.businessType) {
            profile.businessType = userData.businessType;
          }
          if (userData.timeLineForFinance) {
            profile.timeLineForFinance = userData.timeLineForFinance;
          }
          if (userData.formType) {
            profile.formType = userData.formType;
          }
          if (userData.turnover) {
            profile.turnover = userData.turnover;
          }
          if (userData.userProperties) {
            profile.userProperties = userData.userProperties;
          }
          if (userData.financing_intent_status) {
            profile.financing_intent_status = userData.financing_intent_status;
          }
          if (userData.lead_score) {
            profile.lead_score = userData.lead_score;
          }
          window.clevertap.onUserLogin.push({ Site: profile });
          window.clevertap.profile.push({ Site: profile});
          // console.log("✅ CleverTap User Identified:", profile);
        }
        const payload = {
          ...eventData,
          ...(pageName && pageName.trim() ? { PageName: pageName } : {}),
          'Date': new Date().toISOString()
        };
        window.clevertap.event.push(eventName, payload);
        // console.log(`✅ CleverTap Event Pushed: ${eventName}`, payload);
      } catch (error) {
        console.error("❌ Error in pushCleverTapEvent:", error);
      }
    };

    if (typeof window.clevertap.getCleverTapID === "function") {
      onCleverTapReady();
    } else {
      setTimeout(() => {
        if (typeof window.clevertap.getCleverTapID === "function") {
          onCleverTapReady();
        } else {
          console.warn("⚠️ CleverTap SDK not ready — skipping pushCleverTapEvent");
        }
      }, 1000);
    }
  }
};